import * as types from '../types';
import { IStaffNotificationsApi } from '../contracts';
import { HttpApi } from './HttpApi';

const enc = encodeURIComponent;

/** Staff in-app notification center (tracker item 62). */
export class StaffNotificationsHttpApi extends HttpApi implements IStaffNotificationsApi {
  async listStaffNotifications(query: types.StaffNotificationListQuery = {}): Promise<types.StaffNotificationPage> {
    // Only the filters that are set go on the query string (the server rejects blanks)
    const params: Record<string, string | number> = {};
    if (query.unread) params.unread = 'true';
    if (query.type) params.type = query.type;
    if (query.page) params.page = query.page;
    if (query.limit) params.limit = query.limit;
    return (await this.http.get<types.APIResponse<types.StaffNotificationPage>>('/staff-notifications', { params })).data.data;
  }

  async getStaffNotificationUnreadCount(): Promise<types.StaffNotificationUnreadCount> {
    return (await this.http.get<types.APIResponse<types.StaffNotificationUnreadCount>>('/staff-notifications/unread-count')).data.data;
  }

  async markStaffNotificationRead(id: string): Promise<{ id: string; read: true }> {
    return (await this.http.post<types.APIResponse<{ id: string; read: true }>>(`/staff-notifications/${enc(id)}/read`, {})).data.data;
  }

  async markAllStaffNotificationsRead(input: types.StaffNotificationMarkAllInput = {}): Promise<{ updated: number }> {
    return (await this.http.post<types.APIResponse<{ updated: number }>>('/staff-notifications/read-all', input)).data.data;
  }

  async getStaffNotificationPreferences(): Promise<types.StaffNotificationPreferences> {
    return (await this.http.get<types.APIResponse<types.StaffNotificationPreferences>>('/staff-notifications/preferences')).data.data;
  }

  async setStaffNotificationPreferences(
    muted: Partial<Record<types.StaffNotificationType, boolean>>
  ): Promise<types.StaffNotificationPreferences> {
    return (await this.http.put<types.APIResponse<types.StaffNotificationPreferences>>('/staff-notifications/preferences', { muted })).data.data;
  }
}
